module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-book-detail/arrow-down-e7d4dcc545a9bed03a5dbfca11b97641.svg";